import { SortFieldComponent, SortEvent } from '../components/sort-field/sort-field.component';
import { FilterFieldDirective } from './filter-field.directive';
import { NgIterable } from '@angular/core';

//
// Base class for ListViewDirective... a way to prevent circular dependency
// between ListViewDirective and SortFieldComponent because they both reference each other
//
// The parent ListViewDirective will be injected to any SortField or FilterField children
//

export abstract class AbstractListView<T,U extends NgIterable<T>> {
  
  abstract addSortField( field : SortFieldComponent<T,U> );
  abstract addFilterField( field : FilterFieldDirective<T,U> );
  abstract removeFilterField( f : FilterFieldDirective<T,U> );
  abstract removeSortField( f : SortFieldComponent<T,U> );
  abstract onSort( se : SortEvent);
  abstract filter();
}
